var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHdfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "#ED232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20056 4.20067H19.8023V19.8024H4.20056V4.20067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8003 0H13.1993V24H10.8003V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8034H24V13.2024H0V10.8034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40112 8.40133H15.6014V15.6017H8.40112V8.40133Z",
    fill: "#004C8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdfc);
export default __webpack_public_path__ + "static/media/HDFC.5c57ce02cd77bacbca7abad73c8c524d.svg";
export { ForwardRef as ReactComponent };